<template>
  <div class="shareprice">
    <div class="top" v-show="has_info && !spinShow">
      <div class="divider_line">
        <span>股价信息</span>
      </div>
      <div class="uplist">
        <span v-if="stock.length == 1">{{stock[0].market_id | dealName(meta.stock_market)}}</span>
        <Dropdown trigger="hover" placement="bottom-end" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown" v-if="stock.length > 1">
          <a href="javascript:void(0)">
            <span>{{current_market_id | dealName(meta.stock_market)}}</span>
            <Icon type="md-arrow-dropup" v-if="drop_val" />
            <Icon type="md-arrow-dropdown" v-else />
          </a>
          <DropdownMenu slot="list">
            <DropdownItem v-for="item,index in stock" :name="item.market_id" :selected="current_market_id == item.market_id" :key="index">{{item.market_id | dealName(meta.stock_market)}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
    <div class="shareprice-content" v-show="has_info && !spinShow">
      <div class="price">
        <div class="price-l" :class="fontColor(current_data.zde, 0)">
          <span>{{current_data.currency_id | dealName(meta.unit, 'id', 'symbols')}}{{current_data.close}}</span>
          <span v-if="current_data.zde">{{current_data.zde}}</span>
          <span v-if="current_data.pctChg">{{current_data.pctChg}}%</span>
        </div>
        <div class="price-r">
          <span>数据更新日期：{{current_data.date}}</span>
          <span>交易日：{{current_data.date}}</span>
        </div>
      </div>
      <div class="price-infos">
        <div class="price-item">今日开盘价：<span :class="fontColor(current_data.open, next_data.close)">{{current_data.open | empty}}</span></div>
        <div class="price-item">最高价：<span :class="fontColor(current_data.high, next_data.close)">{{current_data.high | empty}}</span></div>
        <div class="price-item">成交量：{{(current_data.volume?current_data.volume/100:'--') | amountJustPrecise2}}手</div>
        <div class="price-item">52周最高：{{current_data.highest_52 | empty}}</div>
        <div class="price-item">动态市盈率：{{current_data.peTTM_v | empty}}</div>
        <div class="price-item">昨日收盘价：{{next_data.close | empty}}</div>
        <div class="price-item">最低价：<span :class="fontColor(current_data.low, next_data.close)">{{current_data.low | empty}}</span></div>
        <div class="price-item">总市值：{{current_data.TC_value | amountPrecise2(current_data.currency_id, meta.unit)}}</div>
        <div class="price-item">52周最低：{{current_data.lowest_52 | empty}}</div>
      </div>
      <div class="price-chart" id="price-chart"></div>
    </div>
    <div v-if="!has_info">
      <Nothing>
        <p>暂无股价信息</p>
      </Nothing>
    </div>
    <Spin fix v-if="spinShow">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>
<script>
import { getStockByEntity, entityDetail } from '../../../service'
import { get_meta } from 'js/get_meta'
import Nothing from '@/components/Nothing2'
import filter from 'js/filter'
export default {
  mixins: [get_meta],
  data() {
    return {
      filter: filter,
      drop_val: false,
      mychart: '',
      option: {
        grid: {
          top: '40px',
          bottom: '60px',
          right: '30px',
          left: '30px',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#404040',
          padding: 12,
          formatter: ''
        },
        xAxis: {
          data: [],
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: ''
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#D5D5D5', // #40444F
              type: 'dashed',
              width: 1
            }
          },
          axisLabel: {
            // interval: (index) => {
            //   return index % 3 == 1
            // },
            textStyle: {
              color: '#999999' // #E9E9EB
            }
          }
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#D5D5D5', // #40444F
              width: 1,
              type: 'dashed',
            }
          },
          axisLabel: {
            textStyle: {
              color: '#999999' // #E9E9EB
            }
          }
        },
        dataZoom: [
          {
              type: 'inside',
              start: 75,
              end: 100,
              // zoomLock: true,
              zoomOnMouseWheel: false
          },
          {
              show: true,
              type: 'slider',
              top: '90%',
              left: '30px',
              right: '30px',
              start: 0,
              end: 100,
              showDetail: false
          }
        ],
        series: [{
          type: 'k',
          barWidth: 10,
          itemStyle: {
            normal: {
              color: 'transparent',
              color0: '#009933',
              borderColor: '#ec0000',
              borderColor0: '#009933'
            }
          },
          data: []
        }]
      },
      current_market_id: '',
      current_data: '',
      next_data: '',
      market_data: [],
      spinShow: true,
      has_info: true,
      stock: []
    }
  },
  components: {
    Nothing
  },
  computed: {
    theme_switch() {
      return this.$store.state.theme_switch
    }
  },
  methods: {
    async getDetail() {
      let res = await entityDetail({
        uid: this.$route.params.uid,
        type: 'base',
        entity_type: 0
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'stock', res.stock)
        if (res.stock.length > 0) {
          this.current_market_id = res.stock[0].market_id
          this.getStockByEntity(this.current_market_id)
        } else {
          this.has_info = false
          this.spinShow = false
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getStockByEntity(market_id) {
      let res = await getStockByEntity({
        entity_uid: this.$route.params.uid,
        market_id: market_id
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'market_data', res.res)
        if (res.res.length > 0) {
          this.$set(this.$data, 'current_data', res.res[res.res.length - 1])
          this.$emit('callbackData', 'SharePrice')
        } else {
          this.has_info = false
        }
        if (res.res.length > 1) {
          this.$set(this.$data, 'next_data', res.res[res.res.length - 2])
        }
        let date_arr = [], series_data = []
        this.market_data.map((item, index) => {
          if (index > 0) {
            date_arr.push(item.date)
            series_data.push([item.open, item.close, item.low, item.high, this.market_data[index - 1].close])
          }
        })
        this.option.tooltip.formatter = (params) => {
          let name = params[0].name,
            open = params[0].data[1],
            close = params[0].data[2],
            lowest = params[0].data[3],
            highest = params[0].data[4],
            before_close = params[0].data[5],
            dw = this.filter.dealName(this.current_data.currency_id, this.meta.unit, 'id', 'symbols')
          let index = this.market_data.findIndex(a => a.date == name)
          return `<div class="chart_tip">
                    <p class="p1">` + name + `</p>
                    <p class="p2">开盘价：<span class="`+ this.fontColor(open, before_close) + `">` + dw + open + `</span></p>
                    <p class="p2">收盘价：<span class="`+ this.fontColor(close, open) + `">` + dw + close + `</span></p>
                    <p class="p2">最高价：<span class="`+ this.fontColor(highest, before_close) + `">` + dw + highest + `</span></p>
                    <p class="p2">最低价：<span class="`+ this.fontColor(lowest, before_close) + `">` + dw + lowest + `</span></p>
                  </div>`
        }
        let num = 100 - Math.round(30 / date_arr.length * 100)
        this.option.dataZoom[0].start = num
        this.option.xAxis.data = date_arr
        this.option.series[0].data = series_data
        this.changeColor()
        this.mychart.setOption(this.option, true)
        this.spinShow = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    fontColor(val1, val2) {
      return val1 < val2 ? 'green' : 'red'
    },
    handleDropdown(val) {
      this.drop_val = val
    },
    haddleScreenDropdown(id) {
      this.mychart.clear()
      this.current_market_id = id
      this.getStockByEntity(id)
    },
    changeColor() {
      this.option.xAxis.axisPointer.lineStyle.color = this.theme_switch ? '#AAAAAA' : '#CCCCCC'
      this.option.xAxis.axisLine.lineStyle.color = this.theme_switch ? '#D5D5D5' : '#40444F'
      this.option.xAxis.axisLabel.textStyle.color = this.theme_switch ? '#999999' : '#E9E9EB'
      this.option.yAxis.splitLine.lineStyle.color = this.theme_switch ? '#D5D5D5' : '#40444F'
      this.option.yAxis.axisLabel.textStyle.color = this.theme_switch ? '#999999' : '#E9E9EB'
    }
  },
  created() {
    this.getMeta(['stock_market', 'unit'])
  },
  mounted() {
    this.mychart = echarts.init(document.getElementById('price-chart'))
    this.$nextTick(() => {
      this.getDetail()
    })
  },
  watch: {
    theme_switch(val) {
      this.changeColor()
      this.mychart.setOption(this.option, true)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.shareprice
  padding 1px 32px 32px 32px
  .top
    display flex
  .divider_line
    flex 1
    margin 32px 0 32px
  .uplist
    flex 0 0 auto
    margin-top 26px
    margin-left 10px
    > span
      color rgba(250, 122, 80, 1)
  >>> .ivu-select-dropdown
    commonBgColor(#2D2F34, #fff)
    commonShadow(0 4px 20px 0 rgba(0, 0, 0, 0.5), 2px 4px 20px 0px rgba(121, 133, 143, 0.2))
    border-radius 0
    .ivu-dropdown-menu
      .ivu-dropdown-item
        commonColor(rgba(255, 255, 255, 0.9), #666)
      .ivu-dropdown-item-selected, .ivu-dropdown-item.ivu-dropdown-item-selected:hover
        color rgba(250, 122, 80, 1) !important
        commonBgColor(#35383F, #f9f9f9)
      .ivu-dropdown-item-selected, .ivu-dropdown-item-selected:hover
        color rgba(250, 122, 80, 1) !important
      .ivu-dropdown-item:hover
        commonBgColor(#35383F, #f9f9f9)
  .shareprice-content
    padding-left 18px
    .price
      display flex
      justify-content space-between
      &-l
        color #DD2200
        font-weight bold
        font-size 36px
        &.green
          color #009933
        span:nth-of-type(2), span:nth-of-type(3)
          font-size 18px
          margin-left 10px
      &-r
        commonColor(#BCBDC1, #999999)
        font-size 14px
        display flex
        align-items flex-end
        line-height 22px
        span+span
          margin-left 10px
    .price-infos
      margin-top 14px
      display grid
      grid-template-columns 1fr 1fr 240px 1fr 154px
      grid-row-gap 15px
      .price-item
        commonColor(#E9E9EB, #666)
        font-size 14px
        .red
          color #DD2200
        .green
          color #009933
    .price-chart
      margin-top 20px
      width 961px
      height 320px
      border-top 1px solid
      commonBorderColor(#40444F, #E9E9E9)
  >>> .chart_tip
    line-height 1
    p+p
      margin-top 8px
    .p1
      color #fff
      font-size 12px
    .p2
      font-size 12px
      color #C8C8C8
      span
        color #fff
        &.green
          color #009933
        &.red
          color #DD2200
</style>